import { Colors, Metrics, Typography } from "../../resources";
import { Orientation, SIconType, Sorting } from "../../types";
import {
  Pressable,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import React, { useState } from "react";

import SIcon from "./SIcon";
import SSpacer from "./SSpacer";
import { noop } from "lodash";

interface IProps {
  label: string;
  unit: string;
  singleFont?: boolean;
  disabled?: boolean;
  sorted?: Sorting;
  width?: number | string;
  onPress?: () => void;
}

const SHeaderTitle: React.FC<IProps> = ({
  label: title,
  unit: subtitle,
  singleFont = false,
  disabled = false,
  sorted = Sorting.None,
  width = Metrics.size90,
  onPress = noop,
}) => {
  const [hover, setHover] = useState<boolean>(false);
  const [pressIn, setPressIn] = useState<boolean>(false);

  const onHoverIn = () => setHover(true);
  const onHoverOut = () => setHover(false);
  const onPressIn = () => setPressIn(true);
  const onPressOut = () => setPressIn(false);

  const titleSortedColor =
    sorted !== Sorting.None ? Colors.midnight : Colors.grey500;
  const titleHoverColor = hover ? Colors.midnight : titleSortedColor;
  const titleColor = hover ? titleHoverColor : titleSortedColor;

  const titleSelectableHoverColor = Colors.blue400;
  const titleSelectableColor = hover
    ? titleSelectableHoverColor
    : titleSortedColor;
  return (
    <View style={[styles.container, { width: width }]}>
      <Pressable
        style={[
          styles.titleContainer,
          hover && styles.hover,
          pressIn && styles.pressIn,
          {
            padding: 2,
          },
        ]}
        onPress={onPress}
        onMouseEnter={onHoverIn}
        onMouseLeave={onHoverOut}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        disabled={disabled}
      >
        <Text
          style={[
            styles.title,
            {
              color: titleColor,
            },
          ]}
        >{`${title} `}</Text>
        <Text style={singleFont ? styles.title : styles.subtitle}>
          {subtitle}
        </Text>
      </Pressable>
      <SSpacer
        type={Orientation.Horizontal}
        space={Metrics.paddingSuperSmall}
      />
      <TouchableOpacity onPress={onPress}>
        {sorted === Sorting.Incremental ? (
          <SIcon
            type={SIconType.SortIncremental}
            color={Colors.blue700}
            size={Metrics.iconSmall}
          />
        ) : null}
        {sorted === Sorting.Decremental ? (
          <SIcon
            type={SIconType.SortDecremental}
            color={Colors.blue700}
            size={Metrics.iconSmall}
          />
        ) : null}
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  titleContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  titleContainerSelected: {
    flexDirection: "row",
    alignItems: "center",
    padding: 6,
    borderRadius: Metrics.borderRadiusStandard,
    borderWidth: 1,
    backgroundColor: Colors.white,
    shadowColor: "#03082e",
    shadowOffset: {
      width: 1,
      height: 2,
    },
    shadowOpacity: 0.2,
    shadowRadius: 4,
  },
  hover: {
    borderRadius: 2,
    backgroundColor: Colors.midnight05,
  },
  hoverSelected: {
    borderRadius: 2,
    backgroundColor: Colors.blue100,
  },
  pressIn: {},
  title: {
    ...Typography.bodyBold,
    textAlign: "center",
  },
  colorHover: {
    color: Colors.midnight,
  },
  subtitle: {
    ...Typography.bodySubtitle,
    color: Colors.grey500,
  },
});

export default SHeaderTitle;
